<div class="cpf-leak-check-container">
  <div class="input-button-wrapper">
    <div class="input-wrapper">
      <input
        class="cpf-input-field"
        [formControl]="cpfControl"
        matInput
        mask="000.000.000-00"
        [dropSpecialCharacters]="true"
        placeholder="{{ 'InsertYourCPF' | translate }}"
        [required]="!question.elective"
        aria-label="CPF"
        aria-describedby="cpf-error"
        inputmode="numeric"
        pattern="[0-9]*"
        (blur)="onBlur()"
      />
    </div>

    <button
      *ngIf="!isLoading"
      mat-raised-button
      class="check-button"
      [class.button-checked]="
        buttonState === 'leaked' || buttonState === 'not-leaked'
      "
      [disabled]="isButtonDisabled()"
      (click)="onCheckClick()"
    >
      <span>{{ getButtonText() | translate }}</span>
    </button>
    <mat-spinner
      *ngIf="isLoading"
      diameter="56"
      class="input-spinner"
    ></mat-spinner>
  </div>

  <div
    *ngIf="buttonState === 'leaked' || buttonState === 'not-leaked'"
    class="result-message"
    [class]="buttonState"
  >
    <mat-icon
      *ngIf="buttonState === 'leaked'"
      class="result-message-icon"
    >
      warning
    </mat-icon>
    {{
      (buttonState === "leaked"
        ? "CPFLeakCheckResultLeaked"
        : "CPFLeakCheckResultNotLeaked"
      ) | translate
    }}
  </div>

  <p class="disclaimer-text">
    {{ "CPFLeakCheckDisclaimer" | translate }}
  </p>
</div>
